import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { appDb } from 'dexie/app.db';
import { ToastrService } from 'ngx-toastr';
import { catchError, from, of, switchMap, throwError } from 'rxjs';

export const apiErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastrService = inject(ToastrService);
  const authService = inject(AuthService);
  return of(null).pipe(
    switchMap(() => {
      if (!navigator.onLine) {
        const offlineError = new HttpErrorResponse({
          error: {
            message:
              'The application is currently offline. Please check your internet connection.',
          },
          status: 0, // A common status for network errors (though not a standard HTTP status)
          statusText: 'Offline',
          url: req.url,
        });
        return throwError(() => offlineError);
      }
      return next(req).pipe(
        catchError((err) => {
          if (err.status === 403) {
            return from(appDb.cacheKeys.clear()).pipe(
              switchMap(() =>
                authService.tokenRefresh().pipe(switchMap(() => next(req)))
              )
            );
          }
          toastrService.error(
            err.error.message || 'somethingWentWrong',
            undefined,
            {
              payload: { notUseTranslate: !!err.error.message },
            }
          );
          throw err;
        })
      );
    })
  );
};
